export default function useDeliveryAreaCode() {
  const possibleDistanceType = ['EXTRA_FAR', 'EXTRA_FAR_PICKUP', 'FAR', 'FAR_PICKUP', 'MODERATE', 'MODERATE_PICKUP', 'NEAR', 'NEAR_PICKUP'];
  const possibleDistanceTypeTH = ['ไกลพิเศษ', 'รับของ ไกลพิเศษ', 'ไกล', 'รับของ ไกล', 'กลาง', 'ใกล้', 'รับของ กลาง', 'รับของ ใกล้'];
  function translateDistanceType(distance: string) {
    if (distance === 'EXTRA_FAR') return 'ไกลพิเศษ';
    if (distance === 'FAR') return 'ไกล';
    if (distance === 'MODERATE') return 'กลาง';
    if (distance === 'NEAR') return 'ใกล้';
    if (distance === 'EXTRA_FAR_PICKUP') return 'รับของ ไกลพิเศษ';
    if (distance === 'FAR_PICKUP') return 'รับของ ไกล';
    if (distance === 'MODERATE_PICKUP') return 'รับของ กลาง';
    if (distance === 'NEAR_PICKUP') return 'รับของ ใกล้';
    return 'NA';
  }

  function distanceTypeToColor(distance: string) {
    let color = 'gray';
    if (distance === 'NEAR') color = 'green';
    if (distance === 'MODERATE') color = 'red';
    if (distance === 'FAR') color = 'blue';
    if (distance === 'EXTRA_FAR') color = 'orange';
    if (distance === 'NEAR_PICKUP') color = 'teal';
    if (distance === 'MODERATE_PICKUP') color = 'pink';
    if (distance === 'FAR_PICKUP') color = 'indigo';
    if (distance === 'EXTRA_FAR_PICKUP') color = 'yellow';
    return color;
  }

  function distanceTypeToLevel(distance: string) {
    let level = 0;
    if (distance === 'NEAR' || distance === 'NEAR_PICKUP') level = 1;
    if (distance === 'MODERATE' || distance === 'MODERATE_PICKUP') level = 2;
    if (distance === 'FAR' || distance === 'FAR_PICKUP') level = 3;
    if (distance === 'EXTRA_FAR' || distance === 'EXTRA_FAR_PICKUP') level = 4;
    return level;
  }

  function distanceTypeToChipClass(distance: string) {
    return `rounded-xl px-3 self-center text-center bg-${distanceTypeToColor(distance)}-300 text-${distanceTypeToColor(distance)}-800`;
  }

  const farthestDeliveryDistanceIndex = (distanceArr: string[]): number => {
    if (distanceArr.length === 0) return -1;
    for (let i = 0; i < possibleDistanceType.length; i += 1) {
      if (distanceArr.indexOf(possibleDistanceType[i]) > -1) return distanceArr.indexOf(possibleDistanceType[i]);
    }
    return -1;
  };

  const farthestDeliveryDistance = (distanceArr: string[]) => {
    if (distanceArr.length === 0) return null;
    for (let i = 0; i < possibleDistanceType.length; i += 1) {
      if (distanceArr.indexOf(possibleDistanceType[i]) > -1) return possibleDistanceType[i];
    }
    return null;
  };

  const farthestDeliveryAreaCode = (deliveries: any[]) => {
    const distanceArr: any[] = [];
    const distanceCode: string[] = [];
    deliveries.forEach((delivery: any) => {
      distanceArr.push(delivery.area?.distanceType || null);
      distanceCode.push(delivery.area?.code || null);
    });
    const index = farthestDeliveryDistanceIndex(distanceArr);
    if (index !== null) return distanceCode[index];
    return null;
  };

  return {
    possibleDistanceType,
    possibleDistanceTypeTH,

    translateDistanceType,
    distanceTypeToColor,
    distanceTypeToLevel,
    distanceTypeToChipClass,
    farthestDeliveryDistanceIndex,
    farthestDeliveryDistance,
    farthestDeliveryAreaCode,
  };
}
